/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-07-18 14:42:20
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-08-30 10:29:32
 * @FilePath: \ioc_base\src\modules\broadcast\option\broadcastAudio.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Dic } from "$utils";
const tableOption = function () {
  return {
    page: true,
    selection: false,
    menuLeft: true,
    index: true,
    indexLabel: "序号",
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    align: "left",
    size: "small",
    maxHeight: "100%",
    labelWidth: "100px",
    menuAlign: "center",
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 350,
    dialogWidth: "600px",
    emptyText: "暂无数据",
    add: "新增联动播放广播信息",
    menuWidth: 100,
    column: [
      {
        label: "联动名称",
        prop: "linkageName",
        slot: true,
        search: true,
        clearable: true,
        addDisplay: true,
        searchDefault: [],
        type: "text",
        overHidden: true,
        span: 24,
        searchPlaceholder: "请输入音频名称",
        rules: [
          {
            required: true,
            message: "请输入音频名称",
            trigger: "blur"
          }
        ]
      },
      {
        label: "事件类型",
        prop: "alarmType",
        type: "select",
        search: true,
        addDisplay: false,
        viewDisplay: true,
        dicData: Dic.find("SENU085"),
        viewFormatter: (row, value) => {
          if (value) {
            return Dic.findByValue("SENU085", Number(value));
          }
          return "";
        },
        // rules: [{
        //   required: true,
        //   message: '请输入车辆类型',
        //   trigger: 'blur'
        // }],
        formatter: function (row, value) {
          return value ? Dic.findByValue("SENU085", Number(value)) : "";
        }
      },
      {
        label: "创建人",
        prop: "creator",
        search: true,
        addDisplay: false,
        viewFormatter: (row, value) => {
          return value;
        }
      },
      {
        label: "创建时间",
        prop: "createTime",
        addDisplay: false,
        type: "text"
      }
    ]
  };
};
export default tableOption;
